// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3oY_k","notes":"Notes_notes__3FfUb","note":"Notes_note__3mELh","markdown":"Notes_markdown__2VKkn"};